<template>
  <div>
    <Head title="Sety" />
    <h1 class="mb-8 text-3xl font-bold">Sety</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="/sets/create">
        <span>Vytvořit</span>
        <span class="hidden md:inline">&nbsp;set</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Název</th>
            <th class="pb-4 pt-6 px-6">Model</th>
            <th class="pb-4 pt-6 px-6 text-center">Duplikovat</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="set in sets.data" :key="set.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/sets/${set.id}/edit`">
                {{ set.name }}
                <icon v-if="set.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/sets/${set.id}/edit`" tabindex="-1">
                {{ set.model }}
              </Link>
            </td>
            <td class="text-center border-t">
              <Link class="btn-outline-indigo px-2 py-2 text-xs" :href="`/sets/${set.id}/duplicate`" method="post" tabindex="-1"> duplikovat </Link>
            </td>
          </tr>
          <tr v-if="sets.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">Zatím není vytvořený žádný set</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="sets.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    sets: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/sets', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
